export default __webpack_public_path__ + "static/media/placeholder.3f04e35d.png";